import { useEffect, useState } from "react";

/*
 * Shared lightbox state/behaviour for any gallery layout section.
 * Each section keeps its own instance (its own `items` slice), so
 * prev/next wraps within that section only.
 */
export default function useLightbox(items) {
  const [activeIndex, setActiveIndex] = useState(null);

  const open = (index) => setActiveIndex(index);
  const close = () => setActiveIndex(null);

  const showPrev = () =>
    setActiveIndex((prev) =>
      prev === null ? null : (prev - 1 + items.length) % items.length
    );

  const showNext = () =>
    setActiveIndex((prev) => (prev === null ? null : (prev + 1) % items.length));

  useEffect(() => {
    if (activeIndex === null) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") close();
      if (event.key === "ArrowLeft") showPrev();
      if (event.key === "ArrowRight") showNext();
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeIndex, items.length]);

  return {
    activeIndex,
    activeItem: activeIndex !== null ? items[activeIndex] : null,
    open,
    close,
    showPrev,
    showNext,
  };
}
